module.exports = ".table .btn-sm {\n  padding: 0.08rem 0.5rem; }\n\n.table .filter-row th {\n  position: relative; }\n  .table .filter-row th .clear {\n    position: absolute;\n    top: 0.75rem;\n    right: 0.76rem;\n    cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/settings/companies/companies.component.scss
// module id = 580
// module chunks = 1